import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div className="banner__area" style={{backgroundImage: `url('assets/img/banner.png')`}}>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="banner__area-content">
                            <h1><span>TME</span>SPORTS</h1> 
                            <Link className="theme-btn" to="/prorating">Players rating <i className="fal fa-long-arrow-right"></i></Link> 
                        </div>
                    </div>
                </div>
            </div>
            <div className="banner__area-bottom">
                <div className="banner__area-bottom-icon">
                    <ul>
                        <li><a target='_blank' href="https://t.me/tmt_org"><i className="fab fa-telegram"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Banner;